import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftTypePersonProps } from './props';
import { SarlaftTypePerson } from '../../../../../../shared/types/modules/sarlaft';
import { asyncGetParams } from '../../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';

export const useSarlaftTypePerson = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftTypePersonProps) => {
    const [personTypes, setPersonTypes] = useState<ISelect[]>([]);

    const onSubmit = (data: SarlaftTypePerson) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        const typeDefault = personTypes.filter((type) =>
            type.name.includes('Natural')
        );
        formik?.setFieldValue(
            'typePerson',
            typeDefault[0]?.id || data?.typePerson
        );
    }, [data, personTypes]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PERSON_TYPE).then((items) =>
            setPersonTypes(items)
        );
    }, []);

    return {
        formik,
        personTypes,
    };
};
